<ddj-spinner [hideBackground]="true"></ddj-spinner>

<style>
    section {
        width: 100%;
        height: calc(100vh - 75px);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    h2 {
        color: var(--primary-color);
    }
</style>
